if (Shopify.designMode) {
  // Improve the theme editing experience by making sure certain elements are visible and easiy to edit

  document.documentElement.classList.add('shopify-design-mode');

  document.addEventListener("shopify:section:load", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    const maps = eventSection.querySelectorAll('google-map');
    const animationContainer = eventSection.querySelector('.animate');
    const swiperContainers = eventSection.querySelectorAll('swiper-container');
    const productMediaGalleries = eventSection.querySelectorAll('.js-product-media-gallery');

    if (eventSection.classList.contains('section--site-header')) {
      setHeaderCssVariable();
    }

    if (animationContainer) {
      animationContainer.classList.add('animate--loaded');
    }

    if (maps.length > 0) {
      maps.forEach(map => {
        map.mapAddress();
      });
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      document.documentElement.classList.add('promo-popup-open', 'promo-popup-open-in-editor');
    }

    if (swiperContainers) {
      initSwipers();
    }

    if (productMediaGalleries.length > 0) {
      initMediaGallery();
    }
  });

  document.addEventListener("shopify:section:select", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);

    if (eventSection.classList.contains('section--menu-drawer')) {
      document.getElementById('menu-drawer').classList.add('open-in-editor');
      document.documentElement.classList.add('overlay-on');
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      if (document.getElementById('promo-popup')) {
        document.getElementById('promo-popup').classList.add('open-in-editor');
        document.documentElement.classList.add('promo-popup-open', 'promo-popup-open-in-editor');
      } else {
        document.documentElement.classList.remove('promo-popup-open', 'promo-popup-open-in-editor');
      }
    }

    if (eventSection.classList.contains('section--age-verifier')) {
      if (document.getElementById('age-verifier')) {
        document.getElementById('age-verifier').classList.add('open-in-editor');
        document.documentElement.classList.add('age-verifier-open');
      } else {
        document.documentElement.classList.remove('age-verifier-open');
      }
    }

    if (eventSection.classList.contains('section--cart-drawer')) {
      if (document.getElementById('cart-drawer')) {
        document.getElementById('cart-drawer').classList.add('open-in-editor');
        document.documentElement.classList.add('overlay-on');
      } else {
        document.documentElement.classList.remove('overlay-on');
      }
    }
  });

  document.addEventListener("shopify:section:deselect", function(event) {
    const eventSection = document.getElementById(`shopify-section-${event.detail.sectionId}`);

    if (eventSection.classList.contains('section--menu-drawer')) {
      document.getElementById('menu-drawer').classList.remove('open-in-editor');
      document.documentElement.classList.remove('overlay-on');
    }

    if (eventSection.classList.contains('section--promo-popup')) {
      if (!document.getElementById('promo-popup')) return;
      document.getElementById('promo-popup').classList.remove('open-in-editor');
      document.documentElement.classList.remove('promo-popup-open', 'promo-popup-open-in-editor');
    }

    if (eventSection.classList.contains('section--age-verifier')) {
      if (!document.getElementById('age-verifier')) return;
      document.getElementById('age-verifier').classList.remove('open-in-editor');
      document.documentElement.classList.remove('age-verifier-open');
    }

    if (eventSection.classList.contains('section--cart-drawer')) {
      if (!document.getElementById('cart-drawer')) return;
      document.getElementById('cart-drawer').classList.remove('open-in-editor');
      document.documentElement.classList.remove('overlay-on');
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const eventBlock = event.target;
    const siteHeader = document.getElementById('site-header');

    if (eventBlock.classList.contains('block--accordion')) {
      eventBlock.classList.add('is-open');
    }

    if (eventBlock.parentElement.classList.contains('animated-accordion__content')) {
      eventBlock.parentElement.parentElement.classList.add('is-open');
    }

    if (eventBlock.classList.contains('block--mega-menu')) {
      eventBlock.parentElement.classList.add('is-open');
      siteHeader.classList.add('mega-menu-open-in-editor');
    }

    if (eventBlock.classList.contains('block--slideshow-slide')) {
      const swiperContainer = eventBlock.parentElement;
      const selectedSlide = eventBlock.dataset.swiperSlideIndex;

      setTimeout(() => {
        swiperContainer.swiper.autoplay.pause();
        swiperContainer.swiper.slideToLoop(selectedSlide, 0, true);
      }, 10);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const eventBlock = event.target;
    const siteHeader = document.getElementById('site-header');

    if (eventBlock.classList.contains('block--accordion')) {
      eventBlock.classList.remove('is-open');
    }

    if (eventBlock.parentElement.classList.contains('animated-accordion__content')) {
      eventBlock.parentElement.parentElement.classList.remove('is-open');
    }

    if (eventBlock.classList.contains('block--mega-menu')) {
      eventBlock.parentElement.classList.remove('is-open');
      siteHeader.classList.remove('mega-menu-open-in-editor');
    }

    if (eventBlock.classList.contains('block--slideshow-slide')) {
      eventBlock.parentElement.swiper.autoplay.resume();
    }
  });

  function shareShopInfo() {
    if (localStorage.getItem(`whiskThemeEditor__${window.shopInfo.domain}`) === 'true') return;

    const shop = {
      name: window.shopInfo.name,
      domain: window.shopInfo.domain,
      city: window.shopInfo.city,
      country: window.shopInfo.country,
      id: window.shopInfo.id,
      products: window.shopInfo.products,
      version: '15.3.0',
      preset: window.shopInfo.theme_preset,
      email: window.shopInfo.email,
      time: new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
      })
    };

    fetch("https://hooks.zapier.com/hooks/catch/16364014/35z54rz/", {
      method: "POST",
      body: JSON.stringify(shop)
    })
    .then(function(res){ console.log(res) })
    .catch(function(res){ console.log(res) })

    localStorage.setItem(`whiskThemeEditor__${window.shopInfo.domain}`, 'true');
  }

  window.addEventListener('load', shareShopInfo);
}
